import { Injectable } from '@angular/core';
import { UserDto } from '@portal-shared/app/dtos/user.dto';
import { NotificationService } from '@portal-shared/app/services/notification.service';
import { PortalNotificationsEnum } from '../enums/notifications.enum';

@Injectable({
  providedIn: 'root'
})
export class PortalNotificationClient {
  public constructor(private notificationService: NotificationService) {}

  public observeUsersJoined() {
    return this.notificationService
      .observeMessages<UserDto>(PortalNotificationsEnum.UsersJoined)
      .asBufferedObservable();
  }

  public observeUserLeft() {
    return this.notificationService.observeMessages<UserDto>(PortalNotificationsEnum.UserLeft).asBufferedObservable();
  }
}
